import { Transcript } from './types';
import { axiosClient } from '../axiosClient';

export const getTranscripts = (id: number) => {
  return axiosClient.get<Transcript[]>(`/transcripts/${id}`);
};
